import { useEffect, useRef, useState } from 'react';
import { CLOCK_TEMPLATES } from './clockTemplates';
import { readClock } from './clockReader';
import { createPhaseTracker, formatPhase } from './phaseTracker';

const SAMPLE_INTERVAL_MS = 1500; // 게임 화면에서 읽는 간격

/**
 * 게임 중(enabled)에 공유 화면의 D1에서 "N일 차 + 낮/밤"을 주기적으로 읽어 지금이 몇 일차 낮/밤인지 알려 준다.
 * - captureClockImage(): D1 영역 이미지(760×120). 공유 중이 아니면 null.
 * 반환: { phase: { day, phase } | null, label: '2일차 낮' | null }
 */
export default function useCurrentPhase({ enabled, captureClockImage }) {
  const trackerRef = useRef(null);
  if (!trackerRef.current) {
    trackerRef.current = createPhaseTracker();
  }
  const captureRef = useRef(captureClockImage);
  captureRef.current = captureClockImage;
  const [phase, setPhase] = useState(null);

  useEffect(() => {
    const tracker = trackerRef.current;
    if (!enabled) {
      tracker.reset();
      setPhase(null);
      return undefined;
    }
    const sample = () => {
      const image = captureRef.current && captureRef.current();
      if (!image) {
        return;
      }
      const current = tracker.update(readClock(image, CLOCK_TEMPLATES));
      // 값이 같으면 같은 객체를 유지해 불필요한 렌더링을 피한다
      setPhase((prev) => (prev && current && prev.day === current.day && prev.phase === current.phase ? prev : current));
    };
    sample();
    const timer = setInterval(sample, SAMPLE_INTERVAL_MS);
    return () => clearInterval(timer);
  }, [enabled]);

  return { phase, label: formatPhase(phase) };
}
